import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { useCallback } from 'react';
import { ExportFeedbackRecordsModalContent } from '../ExportFeedbackRecordsModalContent';

interface UseGetExportFeedbackRecordsModalOptions {
  exportFeedback: ({
    includeContent,
    includeOriginalContent,
  }: {
    includeContent?: boolean;
    includeOriginalContent?: boolean;
  }) => Promise<void>;
  feedbackCount?: number;
}

export const useGetExportFeedbackRecordsModal = ({
  exportFeedback,
  feedbackCount,
}: UseGetExportFeedbackRecordsModalOptions) => {
  const { openModal } = useMuiModalContext();
  return useCallback(
    () =>
      openModal({
        contentComponent: () => (
          <ExportFeedbackRecordsModalContent
            exportFeedback={exportFeedback}
            feedbackCount={feedbackCount}
          />
        ),
        modalProps: {
          fullWidth: true,
          maxWidth: 'lg',
          PaperProps: {
            elevation: 3,
            sx: { width: '800px' },
          },
        },
      }),
    [openModal, feedbackCount, exportFeedback],
  );
};
